import { ls } from '@/services/storage'
import { formatPhoneNumber07 } from '@/utils/filters'

const PASSCODE_REQUEST_LOCK_SECONDS = 60

export default {
  namespaced: true,
  state: {
    storagePasscode: ls.get('passcode-v2', null)
  },
  mutations: {
    set (state, { phoneNumber, globalLogin = false }) {
      const data = {
        phoneNumber: formatPhoneNumber07(phoneNumber),
        globalLogin,
        requestExpires: new Date().getTime() + PASSCODE_REQUEST_LOCK_SECONDS * 1000
      }
      state.storagePasscode = data
      ls.set('passcode-v2', data)
    },
    delete (state) {
      state.storagePasscode = null
      ls.del('passcode-v2')
    }
  }
}
